import {SActionBtn, SIDRender, SLowcodeList, STableActions, SDropdown, STags} from "shj-components";
import React, {useEffect, useRef, useState} from "react";
import {getAuth} from "@/utils/auth.ts";
import {message,Tooltip, TreeSelect} from "antd";
import CheckThePhone from "@/components/CheckThePhone";
import {useNavigate, useSearchParams} from "react-router-dom";
import {clueExport, getBizStatus, getClueDetail, salesWorkPage} from "@/services/saleOpServices.ts";
import {apiData2Table} from "@/utils/data.ts";
import AddNewPlanModal from "@/components/AddNewPlanModal";
import {useDebounceEffect, useSetState} from "ahooks";
import {getEnums, httpOrgList} from "@/services/homeService.ts";
import {getChannelBrandAgent, getChannels, getChannelType} from "@/services/getUsers.ts";
import {getAllCompanyMrn, getRealEstateList} from "@/services/customerServices.ts";
import {departmentTree} from "@/services/content.ts";
import {filterSearchData} from "@/utils/common.ts";
import {getAnchorFn, getUserIdentityFn} from "@/pages/clueManage/utils.tsx";
import wx_add from '@/assets/wx_add.svg'
import wx_add_ok from '@/assets/wx_add_ok.svg'
import {fileConfirm} from "@/utils/file.ts";
import AllowcateWorkerModal from "@/components/AllowcateWorkerModal";
import ExportModal from "@/pages/clueManage/clueList/components/ExportModal.tsx";
import ExpandTableList from "@/pages/salesWorkbench/workbenchList/components/ExpandTable";
import {isArray, isEmpty} from "lodash-es";
import dayjs from "dayjs";
import {getUser} from "shj-utils";
import {InfoCircleOutlined, PhoneFilled} from "@ant-design/icons";
import ClueCallModal from "@/pages/salesWorkbench/workbenchList/components/clueCallModal";
import styles from '../../index.module.less'
import {useAtom} from "jotai";
import {callDataAtom, callStateAtom} from "@/pages/callTool/intelligentOutboundCall/components/Info/store";
import { onCallUp} from "@/pages/callTool/intelligentOutboundCall/components/Info/store/fn.tsx";
import {SeatAddClueModal} from "@/pages/salesWorkbench/workbenchList/components/SeatAddClueModal";
import DuplicatedModal from "@/pages/crm/callCenter/callManage/components/head/duplicatedModal.tsx";
import AddNewFollowModal from "@/pages/crm/sellPlan/components/AddNewFollowModal";
import classNames from "classnames";
import {openInNewTab} from "@/utils/queryParse.ts";
import {isHeadquarters} from "@/utils/common.ts";
import AddModal from "@/pages/salesWorkbench/workbenchList/dialog/addModal";
import getConfig from "./config.tsx";
import {ChannelAddClueModal} from "@/pages/salesWorkbench/workbenchList/components/ChannelAddClueModal";
import {DispatchDesignerModal} from "@/pages/salesWorkbench/workbenchList/components/DispatchDesigner";

const ClueList = (props) => {
  const listRef = useRef<any>()
  const {companyId} = getUser() || {}
  const [search] = useSearchParams()
  const clueId = search.get('clueId')
  const [sourceChannel, setSourceChannel] = useState([])
  const [searchChange, setSearchChange] = useState(true)
  const [searchQuery, setSearchQuery] = useState({})
  const [state, setState] = useSetState({
    open: false,
    editOpen: false,
    record: {},
    id: '',
    exportOpen: false,
    exportCode: 'ClueInfoDyhExcelImpl',
    changeDispatcherOpen: false, //改派
    batchEditId: [],
    orderRequest: ['orderCode', 'orderStatusList', 'dealStatusList', 'signTime', 'startWorkTime', 'completedTime'],
    callModalOpen: false,
    callClueId: '',
    isSeat: false,
    seatAddOpen: false,
    channelAddOpen: false,
    clueBtnLoading: false,
    searchRepeatOpen: false,
    openNewFollow: false,
    currentEditClueId: '',
    buttonKey: '',
    modalTitle: '',
    openDispatchDesigner: false,
  })
  const [batchOrgId, setBatchOrgId] = useState('');
  // useEffect(() => {
  //   if (props.clueStatus !== null) {
  //     listRef.current?.reload()
  //   }
  // }, [props.clueStatus]);
  const [callData, setCallData] = useAtom(callDataAtom)
  const [callState, setCallState] = useAtom(callStateAtom)

  useEffect(() => {
    onCompanyChange(companyId)
  }, [companyId]);

  const fetchList = ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      const newQuery = handleParams(query)
      salesWorkPage({params: {pageId: current, pageSize}, data: {...newQuery}}).then((res: any) => {
        resolve(apiData2Table(res))
      }).catch(reject)
    })
  }

  const handleParams = (query) => {
    // 分配人
    if (query.deptId || query.ucenterUserId) {
      const {deptId, ucenterUserId} = query
      query.relativesRequest = {
        deptId,
        ucenterUserId,
        dutyType: ucenterUserId && "subsidiary.salesman"
      }
      delete query.deptId
      delete query.ucenterUserId
    }
    // 订单维度查询条件
    const orderParams = !isEmpty(query) && state.orderRequest.filter(key => query[key])
    if (orderParams && orderParams?.length){
      const orderRequest = {}
      orderParams.forEach(key => {
        if(key.includes('Time')){
          orderRequest[key + 'Start'] = dayjs(query[key][0]).format('YYYY-MM-DD HH:mm:ss') || ''
          orderRequest[key + 'End'] = dayjs(query[key][1]).format('YYYY-MM-DD HH:mm:ss') || ''
        } else {
          orderRequest[key] = query[key]
        }
        delete query[key]
      })
      query.orderRequest = orderRequest
    }

    const query1 = filterSearchData(query, ['firstDate', 'lastFollowTime', 'appointmentTime', 'dispatchTime','validityTime', 'signUpTime'])
    const newQuery1 = filterSearchData(query1, ['createdTime'], ['StartWith', 'EndWith'])

    const newQuery = {...props.query, ...newQuery1}

    setSearchChange(!searchChange)
    setSearchQuery({...newQuery, status: query.status || undefined})
    return newQuery
  }

  const onAdd = () => {
    setState({open: true, id: ''})
  }

  const onEdit = (record) => {
    setState({editOpen: true, id: record.id})
    getClueDetail(record.id).then((res: any) => {
      setState({record: res})
    })
  }

  const getStatusOptions = () => {
    return Promise.all([
      httpOrgList(),
      getChannels(),
      getChannelBrandAgent(),
      getChannelType(),
      getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.BizOpTypeEnum'),
      getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.ClueStatusEnum'),
      getAnchorFn('ADVERT'),
      getUserIdentityFn(),
      getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.clue.DispatchTypeEnum'),
      getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.clue.DealStatusEnum'),
      getBizStatus(),
      getEnums('plus-trade','com.shj.saas.plus.trade.enums.OrderStateEnum' ),
      getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.HouseNatureEnum'),
      getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.SignBillIntentEnum'),
    ]).then(resp => {
      setSourceChannel(resp[1])
      return {
        companyList: resp[0],
        sourceChannel: resp[1],
        channelBrand: resp[2],
        channelType: resp[3],
        typeListArr: resp[4],
        clueStatusEnum: resp[5],
        anchor: resp[6],
        seat: resp[7],
        dispatchTypeEnum: resp[8],
        dealStatusEnum: resp[9],
        bizStatus: handleObj(resp[10]),
        orderStateEnum: resp[11],
        houseNatureEnums: resp[12],
        signBillIntentEnum: resp[13],
        stateList: [{label: '是', value: true}, {label: '否', value: false}],
      }
    })
  }

  const handleObj = (obj) => {
    const keys = Object.keys(obj) || []
    return keys?.map(key => ({label: obj[key], value: key}))
  }

  const onCompanyChange = async (value: any) => {
    if (value) {
      getRealEstateList({orgId: value}).then(res => {
        listRef?.current?.updateSearchData('buildingId', res)
      })
      departmentTree(value, {
        "direction": "DOWN"
      }).then(res => {
        listRef?.current?.updateSearchData('saleDept', res)
        listRef?.current?.updateSearchData('designDept', res)
      })
      getAllCompanyMrn({userIdentityFilter: {companyId: value}}).then(res => {
        listRef?.current?.updateSearchData('salesman', res)
        listRef?.current?.updateSearchData('designer', res)
      })

    } else {
      listRef?.current?.updateSearchData('buildingId', [])
      listRef?.current?.updateSearchData('saleDept', [])
      listRef?.current?.updateSearchData('salesman', [])
      listRef?.current?.updateSearchData('designer', [])
    }
  }

  const onMarketerDepChange = (v) => {
    if (v) {
      getAllCompanyMrn({directlyUnder: {orgId: v, includeChild: true}}).then(res => {
        listRef?.current?.updateSearchData('salesman', res)
      })
    } else {
      const companyId = listRef.current.getSearch()?.getFieldValue('orgId')
      if (companyId) {
        getAllCompanyMrn({userIdentityFilter: {companyId}}).then(res => {
          listRef?.current?.updateSearchData('salesman', res)
        })
      } else {
        listRef?.current?.updateSearchData('salesman', [])
      }
    }
  }

  const onSearchReset = () => {
    listRef?.current?.updateSearchData('buildingId', [])
    listRef?.current?.updateSearchData('saleDept', [])
    listRef?.current?.updateSearchData('salesman', [])
  }

  const onDesignDeptChange = (v) => {
    if (v) {
      getAllCompanyMrn({directlyUnder: {orgId: v, includeChild: true}}).then(res => {
        listRef?.current?.updateSearchData('designer', res)
      })
    } else {
      const companyId = listRef.current.getSearch()?.getFieldValue('orgId')
      if (companyId) {
        getAllCompanyMrn({userIdentityFilter: {companyId}}).then(res => {
          listRef?.current?.updateSearchData('designer', res)
        })
      } else {
        listRef?.current?.updateSearchData('designer', [])
      }
    }
  }

  const onBatchChangeDesign = (param) => {
    const {selectedRowKeys, selectedRows} = param;
    const orgId = selectedRows?.[0]?.orgId;
    const isSameOrg = selectedRows?.every(item => item.orgId === orgId);
    if (!isSameOrg) {
      message.error('只能选择相同门店的线索');
      return;
    }
    setBatchOrgId(orgId);
    setState({openDispatchDesigner:  true, batchEditId: selectedRowKeys})
  }

  // 查重
  const onSearchRepeat = () => {
   setState({searchRepeatOpen: true})
  }

  // 导出
  const onExport = async () => {
    const searchData_ = listRef.current.getSearch().getFieldsValue()
    const values = handleParams(searchData_)
    message.loading({content: '导出中'})
    clueExport(values)
        .then(() => {
          message.destroy()
          fileConfirm()
        })
        .catch(() => {
          message.destroy()
        })
  }
  // 导出压缩包
  const onExportZip = async () => {
    setState({exportOpen: true, exportCode: 'ClueInfoDyhExcelImpl'})
  }
  // 导出明细
  const onExportDetail = async () => {
    setState({exportOpen: true, exportCode: 'ClueFollowLogExcelImpl'})
  }

  const onChangeEmp = (batchEditId, key= 'ASSIGN_SALES', title?) => {
    setState({batchEditId, changeDispatcherOpen: true, buttonKey: key, modalTitle: title})
  }

  const onBatchChange = ({selectedRowKeys}) => {
    onChangeEmp(selectedRowKeys, 'REASSIGN_SALES')
  }

  const onBatchChangeSeat = ({selectedRowKeys}) => {
    onChangeEmp(selectedRowKeys, 'ASSIGN_SEAT_MAN')
  }

  // 写日志
  const onAddLog = (clueId) => {
    setState({openNewFollow: true, currentEditClueId: clueId})
  }

  //子表格
  const expandedRowRender = (record, a, b, c) => {
    return <ExpandTableList clueId={record.id} listRef={listRef} open={c} searchChange={searchChange} searchQuery={searchQuery}/>
  }

  const onCall = (record) => {
    onCallUp({detailInfo: record, callData, setCallData, callState})
    setState({callModalOpen: true, callClueId: record.id})
  }

  const onSeatAdd = () => {
    setState({seatAddOpen: true})
  }

  const onAddNormal = () => {
    setState({editOpen: true})
  }

  const onChannelAdd = () => {
    setState({channelAddOpen: true})
  }

  const extension = {
    onSearchReset,
    request: {fetchList, getStatusOptions},
    events: {
      onAdd,
      onAddNormal,
      onSeatAdd,
      onChannelAdd,
      onCompanyChange,
      onMarketerDepChange,
      onDesignDeptChange,
      onBatchChangeDesign,
      onBatchChange,
      onSearchRepeat,
      onBatchChangeSeat,
    },
    auth: getAuth(),
    rowKey: 'id',
    status: {
      btnDisabled: ({selectedRowKeys}: any) => selectedRowKeys.length <= 0,
    },

    customRender: {
      treeSelect(props: any) {
        const {key, placeholder}: any = props
        return (
            <TreeSelect
                key={key}
                placeholder={placeholder || '请选择客户来源'}
                allowClear
                treeCheckable
                showSearch
                treeData={sourceChannel}
                maxTagCount="responsive"
                popupMatchSelectWidth={false}
                fieldNames={{label: 'label', value: 'id', children: 'children'}}
                treeNodeFilterProp={'label'}
                style={{width: '100%'}}
            />
        )
      },
      clueIdRender(text: any, record: any, index: any) {
        let label = text
        if (record?.sourceFlag == 'CONTENT_SHARING') {
          label += `-内`
        }
        return (
            <SIDRender
                id={label}
                onClick={() => {
                  openInNewTab(`/mos/saleOp/salesWorkBench/salesWorkBenchDetail/${record.id}`)
                }}
            />
        )
      },
      checkPhone(text: any, record: any, index: any) {
        return (
            <div className={classNames([styles.flexStart, styles.phoneColEllipsis])}>
              <CheckThePhone
                clueId={record.id}
                initValue={text}
                auth="salesWorkBenchClueViewPhone"
              />
              {text && callState.isSeat && <div className={styles.callIconBox} onClick={() => onCall(record)}>
                <PhoneFilled className={styles.callIcon}/>拨号</div>}
            </div>
        )
      //   salesWorkBench
      },
      stateRender(text) {
        return <STags itemKey={text} />
      },
      nameRender(v, record) {
        return <div style={{display: 'flex'}}>
          <img style={{width: 20, height: 20, marginRight: 5}} src={record.salesAddQvFlag ? wx_add_ok : wx_add}/>
          {v}
        </div>
      },
      callStatusRender(v, record){
        return <div>拨打/接通： {v || 0}/{record.successCount || 0}</div>
      },
      actionRender(_, record) {
        return <STableActions>
          <SActionBtn auth={'salesWorkBenchAddLog'}
                      onClick={() => onAddLog(record.id)}>写日志</SActionBtn>
          <SActionBtn auth={'salesWorkBenchClueInfoEdit'} onClick={() => onEdit(record)}>编辑</SActionBtn>
          <SActionBtn auth={'salesWorkBenchReassignmentSeat'}
                      onClick={() => onChangeEmp([record.id], 'ASSIGN_SEAT_MAN', '改派云客服')}>改派云客服</SActionBtn>
          <SActionBtn auth={'salesWorkBenchReassignmentSale'}
                      onClick={() => onChangeEmp([record.id], record.sales ? 'REASSIGN_SALES' : 'ASSIGN_SALES', record.sales ? '改派营销员' : '分配营销员')}>{record.sales ? '改派营销员' : '派单'}</SActionBtn>
          {record.customerId && <SActionBtn auth={'salesWorkBenchViewCustomerProfile'}
                                            onClick={() => openInNewTab(`/CrmPlus/customerProfileDetail/${record.customerId}`)}>查看档案</SActionBtn>}
        </STableActions>
      },
      exportRender() {
        const items = [
          {
            label: '导出',
            key: 'salesWorkBenchClueExportButton',
            auth: 'salesWorkBenchClueExportButton',
            onClick: onExport,
            extra: <Tooltip title={'列表查询的线索 + 无效线索'}>
              <InfoCircleOutlined />
            </Tooltip>
          },
          {
            label: '导出明细',
            key: 'salesWorkBenchClueExportDetailsButton',
            auth: 'salesWorkBenchClueExportDetailsButton',
            onClick: onExportDetail,
            extra: <Tooltip title={'列表查询的线索匹配跟进记录时间的线索 + 无效线索匹配跟进记录时间的线索'}>
              <InfoCircleOutlined />
            </Tooltip>
          },
          {
            label: '导出（Zip）',
            key: 'salesWorkBenchClueExportZipButton',
            auth: 'salesWorkBenchClueExportZipButton',
            onClick: onExportZip,
            extra: <Tooltip title={'列表查询的线索匹配线索的创建时间、回单时间、派营销时间、签单时间、认定有效时间、预约到店时间的线索'}>
              <InfoCircleOutlined />
            </Tooltip>
          },
        ]
        return (
            <SDropdown menu={{items}} dropdownType="Button">
              导出
            </SDropdown>
        )
      },
    },
  }

  return (
      <>
        <SLowcodeList config={{
                        ...getConfig(),
                        name: props.listConfigName,
                        [(isHeadquarters() && !clueId) ? '' : 'searchInitialValues']: {orgId: isHeadquarters() ? '' : companyId, id: clueId}
                      }}
                      ref={listRef}
                      searchMode="group"
                      {...extension}
                      expandable={{
                        [(['DESIGN', 'TO_SHOP'].includes(props.clueStatus) || !props.clueStatus || props.clueStateKey === 'statusList') ? 'expandedRowRender' : '']: expandedRowRender,
                        rowExpandable: (record) => ['DESIGN', 'TO_SHOP'].includes(record.status),
                      }}/>
        {state.editOpen && <AddNewPlanModal basicInfo={state.record || {}}
                                        viewPhoneKey={'salesWorkBenchClueViewPhone'}
                                        editPhoneKey={'salesWorkBenchClueEditPhone'}
                                        editCustomerChannelKey={'salesWorkBenchCustomerChannelModificationPermissions'}
                                        editReload={listRef.current?.reload}
                                        reload={listRef.current?.reload}
                                        isEdit={state?.record?.id} open={state.editOpen}
                                        onClose={() => setState({editOpen: false, record: {}})}
        />}
        <AddModal
            open={state.open}
            onClose={() => setState({open: false, record: {}})}
            reload={listRef.current?.reload}
        />
        <ExportModal open={state.exportOpen} taskCode={state.exportCode} onClose={() => setState({exportOpen: false})}/>
        {/** 分配服务人员弹窗 */}
        {state.changeDispatcherOpen &&
            <AllowcateWorkerModal isEditTitle={'改派'} isListOperation={true}
                                  buttonKey={state.buttonKey}
                                  title={state.modalTitle}
                                  reload={listRef.current?.reload}
                                  searchQuery={state.buttonKey === 'ASSIGN_SEAT_MAN' ? {roleCode: 'ykf'} : {}}
                                  isBatch={true}
                                  editId={state.batchEditId} open={state.changeDispatcherOpen}
                                  onClose={() => setState({changeDispatcherOpen: false})}/>}
        {/*一键拨号*/}
        {state.callModalOpen && <ClueCallModal open={state.callModalOpen} clueId={state.callClueId}
                                               fn={listRef.current?.reload}
                                               onClose={() => setState({callModalOpen: false})}/>}
        {/*  云客服新增专属弹窗*/}
        {state.seatAddOpen && <SeatAddClueModal
            open={state.seatAddOpen}
            onClose={() => {setState({seatAddOpen: false})}}
            reload={() => {listRef.current?.reload()}}
        />}
        {/*查重*/}
        <DuplicatedModal open={state.searchRepeatOpen} onCancel={() => setState({searchRepeatOpen: false})} />
        {/** 新增跟进弹窗 */}
        {state.openNewFollow && <AddNewFollowModal buttonKey={''}
                                                   isSeat={true}
                                                   reload={() => listRef.current.reload?.()}
                                                   editId={state.currentEditClueId}
                                                   open={state.openNewFollow}
                                                   onClose={() => setState({openNewFollow: false})}/>}
        {/*  渠道人员新增 */}
        {state.channelAddOpen && <ChannelAddClueModal
            open={state.channelAddOpen}
            onClose={() => setState({channelAddOpen: false})}
            reload={() => listRef.current.reload?.()}/>}
        {/*  批量分配设计师*/}
         <DispatchDesignerModal
          open={state.openDispatchDesigner}
          reload={listRef.current?.reload}
          clueIds={state.batchEditId}
          onClose={() => setState({openDispatchDesigner: false})}
          orgId={batchOrgId}
        />
      </>
  )
}

export default ClueList
